
import Container from '@/components/container';
import LinkWithImage from '../link-with-image';
import { track } from '@/utils/analytics';
import routes from '@/constants/routes';
import Icon from '@/ui-kit/components/icon';
import Gutter from '@/ui-kit/components/gutter';
import { IconType } from '@/ui-kit/components/icon/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

export default {
  /**
   * @component SectionComponent
   *
   * @public
   */

  name: 'SectionComponent',
  components: {
    Icon,
    Gutter,
    Container,
    LinkWithImage,
    Typography,
  },
  props: {
    user: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    buttonTitle: {
      type: String,
      default: 'Details',
    },
    link: {
      type: Object,
      default: () => {},
    },
    checkboxEvent: {
      type: String,
      default: '',
    },
    linkEvent: {
      type: String,
      default: '',
    },
    links: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkboxValue: this.title,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  computed: {
    iconType() {
      return this.link.url
        && !this.link.url.includes('https://bode.ca')
        && !this.link.url.includes('https://www.bodecanada.com')
        ? IconType.ExternalResource
        : IconType.ChevronRight;
    },
  },
  created() {
    // set checkbox value equal checkbox title after removing spaces from it.
    this.checkboxValue = this.checkboxValue.trim().replace(/\s|\.|!|-|&/g, '');
  },
  mounted() {
    // Check if section checkbox has been checked before.
    this.checkIfSavedBefore();
  },
  methods: {
    /**
     * Check if current section checkbox has been checked before
     * and saved in localstorage.
     *
     * @private
     */

    checkIfSavedBefore() {
      // Get buyerChecklist from localstorage.
      const checklistSavedItems = JSON.parse(localStorage.getItem('buyerChecklist'));
      // Check if checkbox value is true.
      if (
        checklistSavedItems
        && checklistSavedItems[this.checkboxValue] === 'true'
      ) {
        const checkBox = this.$refs[this.checkboxValue];
        checkBox.value = `${this.checkboxValue}-true`;
      }
    },

    /**
     * Save checked checkboxs in local storage.
     *
     * @track
     * @param {String} currentValue
     * @private
     */

    saveToLocalStorage(currentValue) {
      const values = currentValue.split('-');

      // Send track event if checkbox has an event.
      if (this.checkboxEvent && values[1] === 'true') {
        const props = {};
        if (this.user) {
          const { userId, email } = this.user;
          props.email = email;
          props.userId = userId;
        }
        track(this.checkboxEvent, props);
      }
      // Get all saved buychecklist items to add the new value
      const checklistSavedItems = JSON.parse(localStorage.getItem('buyerChecklist')) || {};
      // eslint-disable-next-line prefer-destructuring
      checklistSavedItems[values[0]] = values[1];
      localStorage.setItem('buyerChecklist', JSON.stringify(checklistSavedItems));
    },

    /**
     * Navigate to external link or sub-page when click section link.
     *
     * @track
     * @private
     */

    navigateTo() {
      // Send track event if link has an event.
      if (this.linkEvent) {
        const props = {};
        if (this.user) {
          const { userId, email } = this.user;
          props.email = email;
          props.userId = userId;
        }
        track(this.linkEvent, props);
      }

      const { url, uid } = this.link;
      if (url) {
        window.open(url);
      } else {
        this.$router.push(`${routes.buyerChecklist}/${uid}`);
      }
    },
  },
};
